import React from 'react';
import {RectSkeleton} from 'app/views/components/skeleton';
import styles from './tenderBoardListItemSkeleton.module.scss';

export const TenderBoardListItemSkeleton = () => (
    <div className={styles.item}>
        <RectSkeleton width={40} height={40} />
        <div className={styles.info}>
            <RectSkeleton width={200} />
            <div className={styles.type}>
                <RectSkeleton width={80} />
                <RectSkeleton width={30} />
            </div>
            <RectSkeleton width={200} />
            <RectSkeleton width={150} />
        </div>
    </div>
);
